import { render, staticRenderFns } from "./PressReleasessCard.vue?vue&type=template&id=27b94ed1&scoped=true&"
import script from "./PressReleasessCard.vue?vue&type=script&lang=js&"
export * from "./PressReleasessCard.vue?vue&type=script&lang=js&"
import style0 from "./PressReleasessCard.vue?vue&type=style&index=0&id=27b94ed1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b94ed1",
  null
  
)

export default component.exports